import { Fragment } from 'react';

import { Flex, Text } from '@farmersdog/corgi-x';

import styles from './GettingStartedBadges.module.css';

interface GettingStartedBadgesProps {
  badges?: string[];
}

/** Displays a label with additional information on Getting Started cards */
export function GettingStartedBadges({ badges }: GettingStartedBadgesProps) {
  return (
    <Flex
      direction="row"
      gap="xs"
      alignItems="baseline"
      alignContent="center"
      justify="center"
    >
      {badges?.map((badge, index) => (
        <Fragment key={badge}>
          <div className={styles.badge}>
            <Text
              align="center"
              key={badge}
              variant="heading-12"
              color="white"
              as="div"
            >
              {badge}
            </Text>
          </div>
          {index !== badges.length - 1 && <Text variant="heading-12">+</Text>}
        </Fragment>
      ))}
    </Flex>
  );
}
